module.exports = __webpack_public_path__ + "static/media/CAM.1b4bf20c.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/CAM.jpg
// module id = 1715
// module chunks = 1